var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkthroughPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9559 27.7599C21.4111 25.3048 20.6133 21.5047 18.3494 18.1443L25.7018 10.7921C27.6216 12.0161 29.5051 12.4977 30.5593 11.4429L20.0296 0.913086C18.9749 1.96781 19.4569 3.85069 20.6805 5.77041L13.328 13.1226C9.96754 10.8588 6.1673 10.061 3.71216 12.5161L9.80917 18.6129L4.76991 23.652L0.559326 30.9131L7.82016 26.7026L12.8594 21.6635L18.9559 27.7599Z",
    fill: "#2248C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkthroughPin);
export default __webpack_public_path__ + "static/media/walkthrough-pin.640398cd16d2c2c1408dd980395afa9b.svg";
export { ForwardRef as ReactComponent };